module.exports = __webpack_public_path__ + "img/case_7.f3902755.svg";